module.exports = __webpack_public_path__ + "static/fonts/Fontfabric - Nexa-Light.e9f355b5.otf";